// Payment form processing and button locking functionality
$(document).ready(function() {
    let isSubmitting = false;
    
    // Create and add loading overlay to body (hidden by default)
    const loadingOverlay = `
        <div id="loadingOverlay" class="loading-overlay" style="display: none;">
            <div class="loading-content">
                <i class="fas fa-spinner fa-spin mb-3" style="font-size: 3rem; color: #007bff;"></i>
                <h4 class="mb-3">Processing Your Payment</h4>
                <p class="mb-0 text-muted">Please do not close this window or click the back button</p>
                <div class="mt-3">
                    <div class="progress" style="height: 6px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" 
                             role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    // Remove any existing overlay and add new one
    $('#loadingOverlay').remove();
    $('body').append(loadingOverlay);
    
    $('#paymentForm').on('submit', function(e) {
        // Always prevent default form submission
        e.preventDefault();
        
        // Prevent multiple submissions
        if (isSubmitting) {
            return false;
        }
        
        // Validate form first
        if (!$(this)[0].checkValidity()) {
            $(this)[0].reportValidity();
            return false;
        }
        
        // Set submitting flag
        isSubmitting = true;
        
        // Get form data BEFORE disabling fields (disabled fields are not included in FormData)
        const formData = new FormData(this);
        
        // Ensure CSRF token is included
        const csrfToken = $(this).find('input[name="__RequestVerificationToken"]').val();
        console.log('CSRF Token found:', csrfToken ? 'Yes' : 'No');
        if (csrfToken) {
            formData.set('__RequestVerificationToken', csrfToken);
        }
        
        // Debug: Log form data
        console.log('Form action:', $(this).attr('action'));
        console.log('Form data entries:');
        for (let pair of formData.entries()) {
            if (pair[0] !== 'cardNumber' && pair[0] !== 'cvv') {
                console.log(pair[0] + ': ' + pair[1]);
            } else {
                console.log(pair[0] + ': [HIDDEN]');
            }
        }
        
        // Additional debug: Check form element values directly
        console.log('Direct form field check:');
        console.log('firstName:', $('#firstName').val());
        console.log('lastName:', $('#lastName').val());
        console.log('customerEmail:', $('#customerEmail').val());
        console.log('cardNumber length:', $('#cardNumber').val().length);
        console.log('Form element count:', $('#paymentForm input, #paymentForm select').length);
        
        // NOW disable form elements and show loading state
        // Disable and update button
        const $payButton = $('#payButton');
        const $buttonText = $('#buttonText');
        const $loadingSpinner = $('#loadingSpinner');
        
        $payButton.prop('disabled', true);
        $buttonText.hide();
        $loadingSpinner.show();
        
        // Show loading overlay with proper display
        const $overlay = $('#loadingOverlay');
        $overlay.addClass('show');
        $('body').addClass('loading');
        
        // Disable all form inputs to prevent changes (AFTER collecting FormData)
        $('#paymentForm input, #paymentForm select, #paymentForm textarea').prop('disabled', true);
        
        // Prevent browser back button and page refresh
        window.onbeforeunload = function() {
            return "Your payment is being processed. Please do not leave this page.";
        };
        
        // Make AJAX request
        $.ajax({
            url: $(this).attr('action') || '/Payment/FormSubmit',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            timeout: 60000, // 60 second timeout
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            beforeSend: function(xhr) {
                // Additional security: Verify we're on HTTPS
                if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
                    alert('Payment must be processed over a secure connection (HTTPS)');
                    return false;
                }
            },
            success: function(response) {

                console.log(response);
                // Clear the beforeunload event
                window.onbeforeunload = null;
                
                // Security: Validate response structure
                if (typeof response !== 'object' || response === null) {
                    handleError('Invalid server response');
                    return;
                }
                
                if (response.success) {
                    // Success - redirect to thank you page
                    if (response.redirectUrl) {
                        // Add a small delay for better UX
                        setTimeout(function() {
                            //window.location.href = response.redirectUrl;
                            window.location.href = "/Payment/ThankYou";
                        }, 1000);
                    } else {
                        handleError('Invalid redirect URL');
                    }
                } else {
                    // Error - redirect to transaction failed page
                    if (response.redirectUrl) {
                        //setTimeout(function() {
                            //window.location.href = response.redirectUrl;
                            //window.location.href = "/Payment/TransactionFailed";
                        //}, 1000);
                    } else {
                        handleError(response.message || 'Transaction failed');
                    }
                }
            },
            error: function(xhr, status, error) {
                handleError(xhr, status, error);
            }
        });
    });
    
    // Security: Error handling function
    function handleError(xhr, status, error) {
        // Clear the beforeunload event
        window.onbeforeunload = null;
        
        // Hide loading overlay properly
        const $overlay = $('#loadingOverlay');
        $overlay.removeClass('show');
        
        // Re-enable form
        resetForm();
        
        let errorMessage = 'An error occurred while processing your payment.';
        
        if (typeof xhr === 'string') {
            // Simple string error message
            errorMessage = xhr;
        } else if (status === 'timeout') {
            errorMessage = 'The request timed out. Please try again.';
        } else if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
        } else if (xhr && xhr.status === 400) {
            errorMessage = 'Invalid request. Please refresh the page and try again.';
        } else if (xhr && xhr.status === 403) {
            errorMessage = 'Access denied. Please refresh the page and try again.';
        } else if (xhr && xhr.status >= 500) {
            errorMessage = 'Server error. Please try again later.';
        }
        
        // Log error for debugging (remove in production)
        console.error('Payment form error:', { xhr, status, error });
        
        alert(errorMessage + ' Please try again.');
    }
    
    // Function to reset form state
    function resetForm() {
        isSubmitting = false;
        $('#payButton').prop('disabled', false);
        $('#buttonText').show();
        $('#loadingSpinner').hide();
        $('#paymentForm input, #paymentForm select, #paymentForm textarea').prop('disabled', false);
        
        // Ensure overlay is hidden and body class removed
        const $overlay = $('#loadingOverlay');
        $overlay.removeClass('show');
        $('body').removeClass('loading');
    }
    
    // Additional protection: prevent multiple clicks on pay button
    $('#payButton').on('click', function(e) {
        if (isSubmitting) {
            e.preventDefault();
            return false;
        }
    });
    
    // Re-enable form if user navigates back
    $(window).on('pageshow', function(event) {
        if (event.originalEvent.persisted || document.readyState !== 'complete') {
            resetForm();
            window.onbeforeunload = null;
        }
    });
    
    // Additional safety: Hide overlay on page load
    $(window).on('load', function() {
        const $overlay = $('#loadingOverlay');
        $overlay.removeClass('show').css('display', 'none');
    });
});
